import { z } from 'zod';

export const ANALYSIS_EXPORT_KIND = 'analysis';

export const AnalysisExportParamsSchema = z.object({
  analysisVersionId: z.string().uuid(),
});

export type AnalysisExportParams = z.infer<typeof AnalysisExportParamsSchema>;
